import React from 'react';
import { Trans } from 'react-i18next';
import { ContainerSection } from '../../../shared/components/ContainerSection';
import { Text } from '../../../shared/components/Text';
import { Divider } from '../../../shared/components/Divider';

export const About = () => (
  <ContainerSection anchor="who" title="Chi siamo">
    <Text variant="h4">
      <Trans>Titolo</Trans>
    </Text>
    <Text variant="body2" style={{ fontSize: 18 }}>
      <Trans>description1</Trans>
    </Text>
    <Divider height={20} />
    <Text variant="body2" style={{ fontSize: 18 }}>
      <span style={{ fontFamily: 'SofiaProBold' }}>BG</span>
      <Trans>description2</Trans>
    </Text>
    <Divider height={20} />
    <Text variant="body2" style={{ fontSize: 18 }}>
      <span style={{ fontFamily: 'SofiaProBold' }}>BG</span>
      <Trans>description3</Trans>
    </Text>
  </ContainerSection>
);
